import {createContext, ReactNode, useEffect, useState} from "react";
import firebase from "firebase/compat/app";
import 'firebase/compat/auth'
import {APIurl} from "./Utils";
import {Subscription, UserDataModel} from "./Model";


export const AuthContext = createContext<any>(null);

interface AuthProviderProps {
    children?: ReactNode
}

export enum AUTHSTATES {
    UNKNOWN,
    LOGGEDIN,
    LOGGEDOUT,
}

export function AuthProvider(props: AuthProviderProps) {

    const [authState, setAuthState] = useState<AUTHSTATES>(AUTHSTATES.UNKNOWN);
    const [currentUser, setCurrentUser] = useState<any>(null);
    const [userData, setUserData] = useState<any>(null);
    const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);

    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                fetchUserData(user.uid)
                    .then(res => {
                        setUserData(res.user)
                        setSubscriptions(res.subscriptions.data as Subscription[])
                        setCurrentUser(user)
                        setAuthState(AUTHSTATES.LOGGEDIN)
                    })
                    .catch(() => {
                        firebase.auth().signOut().then(() => {
                            setUserData(null)
                            setCurrentUser(null)
                            setAuthState(AUTHSTATES.LOGGEDOUT)
                        })
                    })
            } else {
                setUserData(null)
                setCurrentUser(null)
                setAuthState(AUTHSTATES.LOGGEDOUT)
            }
        })
    }, [])

    async function fetchUserData(uid: string): Promise<{ user: UserDataModel, subscriptions: {data: Subscription[]} }> {
        try {
            const user = firebase.auth().currentUser;
            if (!user) {
                throw new Error(`User not authenticated`);
            }

            const token = await user.getIdToken();

            const response = await fetch(`${APIurl}/getUser/${uid}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            })
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }
            return await response.json();

        } catch (error) {
            throw error;
        }
    }

    return (
        <AuthContext.Provider value={{currentUser, authState, userData, subscriptions}}>
            {props.children}
        </AuthContext.Provider>
    )
}